<div class="reviews-page">
  <div class="reviews-page__title">
    <h2 class="vox-heading-2" translate>reviews.title</h2>
  </div>
  <hr />
  <div class="reviews-page__filters-container">
    <gdp-reviews-filters (filtersChanged)="filterChanged($event)"></gdp-reviews-filters>
  </div>
  <div class="reviews-page__table-container">
    <gdp-reviews-table [reviews]="reviews" [loading]="loading" [loadingLinesArray]="loadingLinesArray"
      (onUpdateReviews)="onReviewChanged()">
    </gdp-reviews-table>
    <gdp-table-pagination *ngIf="reviews?.length !== 0" (onSelectPageSize)="selectPageSize($event)"
      (onChangeCurrentPage)="changeCurrentPage($event)" [totalPages]="pagination.totalPages" [pagination]="pagination"
      [selectedPageSize]="pageSize"></gdp-table-pagination>
  </div>
</div>